import { Inbox, InboxService } from '../../inbox';
import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {MessageService, ConfirmationService, TreeNode} from 'primeng/api';
import {Component, OnInit, Input, EventEmitter, Output, Inject, SimpleChanges, ElementRef, ViewChild, AfterViewChecked, ChangeDetectorRef} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService, AuthenticationService } from '@app/_services';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { User } from '@app/_models';
import { Subscription } from 'rxjs';
import {TaskComponent} from '@app/_components/task/task/task.component';
import {Msg, MsgService} from '@app/_components/msg';
import {TaskListComponent} from '@app/_components/task/task-list/task-list.component';
import {MsgTemplateService} from '@app/_components/msg-template/msg-template.service';
import {MsgRecipient} from '@app/_components/msg-recipient/msg-recipient';
import {ImapConfiguration} from '@app/_components/imap-configuration/imap-configuration';
import {MsgTemplateData} from '@app/_components/msg-template/msg-template-data';
import {TapeChartWikiListComponent} from '@app/_components/tape-chart-wiki/tape-chart-wiki-list/tape-chart-wiki-list.component';
import {BestFitListComponent} from '@app/_components/best-fit/best-fit-list/best-fit-list.component';
import {QuoteContext, QuoteContextService} from '@app/_components/quote/quote-context.service';
import { QuoteService } from '@app/_components/quote/quote.service';
import {Router} from '@angular/router';
import { EditorComponent } from '@tinymce/tinymce-angular';
@Component({
    selector: 'app-inbox',
    templateUrl: './inbox.component.html',
    styleUrls: ['./inbox.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class InboxComponent implements OnInit, AfterViewChecked {

  @ViewChild('btnReplayEmail') btnReplayEmail!: ElementRef<HTMLButtonElement>;
  @ViewChild('mailEditor') mailEditor?: EditorComponent;


  currentUser: User;
	currentUserSubscription: Subscription;
	selectedInbox: any;
	imapConfigId: any;
  fromTask = false;
  defaultContacts: any = [];
  toMailIdsSelected: any = [];
  ccMailIdsSelected: any = [];
  bccMailIdsSelected: any = [];
  @Input() msgTopic: number;
  @Input() msgTopicId: number;
  @Input() formReadOnly = true;
  @Input() showClose = true;
  @Input() inbox: any;
  @Input() msgId: any;
  @Input() templateMsgAudience: any;
  @Output() doAdd = new EventEmitter<any>();
  @Output() doUpdate = new EventEmitter<any>();
  @Output() doUpdateAndDontClose = new EventEmitter<any>();
  @Output() doDelete = new EventEmitter<any>();
  @Output() doArchive = new EventEmitter<any>();
  @Output() keywordClicked = new EventEmitter<string>();
  @Output() tagsChanged = new EventEmitter<{ msgId: number; tags: any[] }>();
  @Input() msgTemplateData: MsgTemplateData;
  msgTemplates: any;
  msgContexts: any;
  msgSubContextMap: any;
  msgSubContextsFiltered: any[] = [];
  msgRoles: any;
  msgContextIds: any[];
  msgSubContextIds: any[];
  msgRoleIds: any[];
  msgContextId: number | null = null;
  msgSubContextId: number | null = null;
  msgRoleId: number | null = null;
  attachments: { filename: string; contentType: string; contentBytes: string }[] = [];
  private shouldFocusEditor = false;
  editorLoading = false;
  isSending    = false;
  isArchiving  = false;
  isReplying   = false;
  isForwarding = false;
  downloadingAttachment: Record<number, boolean> = {};

  /** Smart Parse — auto-extracted quote context (dates, resort, party, guest). */
  parsedContext: QuoteContext | null = null;
  parseBannerVisible = true;

  get isAnyBusy(): boolean {
    return this.isSending || this.isArchiving || this.isReplying || this.isForwarding;
  }

  onMailTagsSelected(tags: any[]): void {
    if (this.inboxId) {
      this.tagsChanged.emit({ msgId: this.inboxId, tags: tags ?? [] });
    }
  }

  openAttachment(msgId: number, index: number): void {
    if (this.downloadingAttachment[index]) return;
    this.downloadingAttachment[index] = true;

    this.msgService.getAttachment(msgId, index).subscribe({
      next: (blob) => {
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
        setTimeout(() => URL.revokeObjectURL(url), 10_000);
        this.downloadingAttachment[index] = false;
      },
      error: () => {
        this.downloadingAttachment[index] = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Attachment Error',
          detail: 'Could not load attachment. Please try again.'
        });
      }
    });
  }
	constructor(
		private primengConfig: PrimeNGConfig,
		private inboxService: InboxService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private authenticationService: AuthenticationService,
		private formBuilder: UntypedFormBuilder,
		private cdRef: ChangeDetectorRef,
    private router: Router,
    private dialog: MatDialog,
    private msgService: MsgService,
		private msgTemplateService: MsgTemplateService,
    private sanitizer: DomSanitizer,
    private quoteContextService: QuoteContextService,
    private quoteService: QuoteService,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
      this.fromTask = data.fromTask,
			this.statuses = inboxService.statuses;
    if( !this.inbox && data.inbox ){
      this.inbox = data.inbox;
    }
    if ( this.inbox && this.inbox.senderEmail){
      this.defaultContacts.push({emailAddress: this.inbox.senderEmail});
    }else{
      this.defaultContacts = [];
    }

    if ( data.msgTopicId){
      this.msgTopicId = data.msgTopicId;
    }
    if ( data.msgTopic){
      this.msgTopic = data.msgTopic;
    }
    if ( data.msgTemplateData){
      this.msgTemplateData = data.msgTemplateData;
    }
		this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
			this.currentUser = user;
		});
	}
	// data
	inboxId: number;
	selectedMsgRecipients: any[] = [];
	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;
	isSendEnable: boolean;
	isReplyEnable: boolean;
	statuses: any;
  emailHtml: any;
  safeEmailHtml: SafeHtml | null = null;
  replayEMailHtml: any;
  baseEmailText: any;
  baseEmailHtml: any;

	validationMessages = {
		'inboxId': [],
		'name': [
			{ type: 'required', message: 'Required' },
			{ type: 'minlength', message: '5 characters minimum' }],
		'description': [
			{ type: 'required', message: 'Required' }
		],
    'subject': [
      { type: 'required', message: 'Required' }
    ],
		'status': [],
		'inboxDate': [],
		'isInbox': [],
	};

	ngOnInit() {
		this.msgContexts = this.inboxService.msgContexts;
		this.msgSubContextMap = this.inboxService.msgSubContextMap;
		this.msgRoles = this.inboxService.msgRoles;

		this.primengConfig.ripple = true;
		this.formBuild();
		if (this.inbox && this.inbox.senderEmail) {
			this.defaultContacts.push({emailAddress: this.inbox.senderEmail});
		}
		// if we were passed the whole inbox object
		if (this.inbox && this.inbox?.msgId) {
			this.isSendEnable = false;
			this.isReplyEnable = true;
			this.inboxId = this.inbox.msgId;
			this.fixDates();
      this.emailHtml = this.inbox?.emailHtml;
	//   this.msgContextId = this.inbox?.msgContext ?? null;
	  this.msgContextId = Number(this.inbox?.msgContext ?? null);
	  this.msgSubContextId = this.inbox?.msgSubContext ?? null;
	  this.msgRoleId = this.inbox?.msgRole ?? null;
		if (this.msgContextId != null) {
			this.onMsgContextChange(this.msgContextId);
		}
			this.form1.patchValue(this.inbox);
			this.imapConfigId = this.form1.value.imapConfigId;
			/*if (this.form1.value.emailHtml == undefined || this.form1.value.emailHtml == 'null'
				|| this.form1.value.emailHtml == '') {
				this.form1.patchValue({emailHtml: this.form1.value.emailText});
			}*/
		} else {
			this.isSendEnable = true;
			this.formReadOnly = false;
			this.editorLoading = true;
		}
		if (this.inbox) {
			this.form1.patchValue(this.inbox);
		}
		this.baseEmailText = this.form1.value.emailText || '';
		this.baseEmailHtml = this.form1.value.emailHtml || '';

    if (this.emailHtml) {
      const bodyHtml = this.extractBodyHtml(this.emailHtml);
      this.safeEmailHtml = this.sanitizer.bypassSecurityTrustHtml(bodyHtml);
    }

    // Smart Parse — populate the quote context banner
    this.runSmartParse();
	}

  /**
   * Runs the email/body text through QuoteContextService and stores the
   * result in `parsedContext`. The banner in the template reads from there.
   * Called on load and whenever the user clicks "Re-parse".
   */
  runSmartParse(): void {
    if (!this.inbox) { this.parsedContext = null; return; }
    const text =
      (this.inbox?.emailText as string) ||
      (this.inbox?.emailHtml as string) ||
      (this.inbox?.msgBody   as string) || '';
    this.parsedContext = this.quoteContextService.parseEmail({
      text,
      subject:     this.inbox?.msgSubject || this.inbox?.subject,
      senderName:  this.inbox?.senderName,
      senderEmail: this.inbox?.senderEmail
    });
  }

  /** Called from the banner "Clear" button — hides banner but keeps context. */
  dismissParseBanner(): void { this.parseBannerVisible = false; }

  private extractBodyHtml(html: string): string {
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      return doc.body && doc.body.innerHTML ? doc.body.innerHTML : html;
    } catch {
      return html;
    }
  }

	onMsgContextChange(contextId: any) {
		this.msgSubContextsFiltered = this.msgSubContextMap[contextId] || [];

		// Reset selected subcontext if it doesn't exist in filtered list
		if (!this.msgSubContextsFiltered.some(sub => sub.value === this.msgSubContextId)) {
			this.msgSubContextId = null;
		}

		if(this.form1.value.msgId && contextId)
		{
			var msg: any = {
				msgContext: contextId,
				msgId: this.form1.value.msgId
			}
			this.inboxService.updateMsgContext(msg).subscribe(
				(res: any) => {
					this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
				},
				(err: any) => {
					console.log('inbox-add FAIL: ' + JSON.stringify(err));
					this.alertService.error(err);
				},
				() => { this.formLoading = false; });
		}
	}

	onMsgSubContextChange(msgSubContext: number) {
		var msg: any = {
			msgSubContext: msgSubContext,
			msgId: this.form1.value.msgId
		}
		this.inboxService.updateMsgSubContext(msg).subscribe(
			(res: any) => {
				this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
			},
			(err: any) => {
				console.log('inbox-add FAIL: ' + JSON.stringify(err));
				this.alertService.error(err);
			},
			() => { this.formLoading = false; });
	}

	onMsgRoleChange(msgRole: number) {
		var msg: any = {
			msgRole: msgRole,
			msgId: this.form1.value.msgId
		}
		this.inboxService.updateMsgRole(msg).subscribe(
			(res: any) => {
				this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
			},
			(err: any) => {
				console.log('inbox-add FAIL: ' + JSON.stringify(err));
				this.alertService.error(err);
			},
			() => { this.formLoading = false; });
	}
	onKeywordClick(value: string | undefined, event: MouseEvent): void {
		event.preventDefault(); // prevent link navigation
		if (value) {
			this.keywordClicked.emit(value);
		}
	}
	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.inboxId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete();
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.inboxService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.inbox = res.data.inbox;
						this.doAdd.emit(this.inbox);
					},
					(err: any) => {
						console.log('inbox-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}
	formUpdate() {
		console.log('inbox: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.inboxService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.inbox = res.data.inbox;
						this.doUpdate.emit(this.inbox);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.inboxService.delete(this.inbox.msgId)
				.subscribe(
					(res: any) => {
						console.log('inbox-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.inbox);
					},
					(err: any) => {
						console.log('inbox-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	fixDates() {
		this.inbox.createDate = moment(this.inbox.createDate).toDate();
	}

	focusEditor(): void {
		setTimeout(() => {
			this.mailEditor?.editor?.focus();
		}, 100); // small delay so editor is initialized
	}

	replyMail() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}

			this.isReplying = true;
			this.cdRef.detectChanges();

			this.fetchAllTemplatesSummary();

			this.isSendEnable = true;
			this.isReplyEnable = false;
      this.formReadOnly = false;
			this.form1.get("imapConfigId").setValue(String(this.imapConfigId));
		if(this.form1.value.emailHtml && this.form1.value.emailHtml != '')
		{
			let emailHtml = '';
			if(this.replayEMailHtml && this.replayEMailHtml !== ''){
			emailHtml = this.replayEMailHtml + "<div dir=\"ltr\" gmail_original=\"1\"><br><br><br></div><div class=\"gmail_quote\"><div dir=\"ltr\" class=\"gmail_attr\">On " + this.form1.value.receivedDate + " " + this.form1.value.senderName + " &lt;<a href=\"mailto:" + this.form1.value.senderEmail + "\">" + this.form1.value.senderEmail + "</a>&gt; wrote:<br></div>" +
				"<blockquote class=\"gmail_quote\" style=\"margin:0px 0px 0px 0.8ex;border-left:1px solid rgb(204,204,204);padding-left:1ex\"><div dir=\"ltr\"><br></div><br>" + this.form1.value.emailHtml;
			}else {
			emailHtml = "<div dir=\"ltr\" gmail_original=\"1\"><br><br><br></div><div class=\"gmail_quote\"><div dir=\"ltr\" class=\"gmail_attr\">On " + this.form1.value.receivedDate + " " + this.form1.value.senderName + " &lt;<a href=\"mailto:" + this.form1.value.senderEmail + "\">" + this.form1.value.senderEmail + "</a>&gt; wrote:<br></div>" +
				"<blockquote class=\"gmail_quote\" style=\"margin:0px 0px 0px 0.8ex;border-left:1px solid rgb(204,204,204);padding-left:1ex\"><div dir=\"ltr\"><br></div><br>" + this.form1.value.emailHtml;
			}
				this.form1.patchValue({ emailHtml: emailHtml});
		}
			const toEmail = this.form1.value.senderEmail;
			//17-06-2025 Divy
			this.defaultContacts = [];
			this.defaultContacts.push({emailAddress: toEmail});
    //   this.defaultContacts.push(toEmail);
      let replyPrefix = (this.form1.value.subject && this.form1.value.subject.startsWith('Re: ')) ? '' : 'Re: ';
			this.form1.patchValue({ toEmails: toEmail, subject: replyPrefix + this.form1.value.subject,
        parentMsgId: this.form1.value.msgId, imapConfigId: this.inbox?.imapConfigurationAPI?.imapConfigurationId});
		//Auto focus on editor
		this.enableEditorAndFocus();
		} catch (error) {
			this.alertService.error(error);
		} finally {
			this.isReplying = false;
		}
	}
  forwardMail() {
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }

      this.isForwarding = true;
      this.cdRef.detectChanges(); 

	  if(!this.msgTemplates || this.msgTemplates.length < 1)
	  {
		  this.fetchAllTemplatesSummary();
	  }
      this.isSendEnable = true;
      this.isReplyEnable = false;
      this.formReadOnly = false;
      this.form1.get("imapConfigId").setValue(String(this.imapConfigId));
	  if(this.form1.value.emailHtml && this.form1.value.emailHtml != '')
		{			
			const emailHtml = "<div dir=\"ltr\" gmail_original=\"1\"><br><br><br></div><div class=\"gmail_quote\"><div>----------------forwarded message ---------------</div><div dir=\"ltr\" class=\"gmail_attr\">On " + this.form1.value.receivedDate + " " + this.form1.value.senderName + " &lt;<a href=\"mailto:" + this.form1.value.senderEmail + "\">" + this.form1.value.senderEmail + "</a>&gt; wrote:<br></div>" +
			  "<blockquote class=\"gmail_quote\" style=\"margin:0px 0px 0px 0.8ex;border-left:1px solid rgb(204,204,204);padding-left:1ex\"><div dir=\"ltr\"><br></div><br>" + this.form1.value.emailHtml;
			   this.form1.patchValue({ emailHtml: emailHtml});
		}
      const toEmail = this.form1.value.senderEmail;
      this.defaultContacts = [];
      let replyPrefix = 'Fwd: ';
      this.form1.patchValue({ toEmails: toEmail, subject: replyPrefix + this.form1.value.subject,
        parentMsgId: this.form1.value.msgId});

		this.enableEditorAndFocus();
    } catch (error) {
      this.alertService.error(error);
    } finally {
      this.isForwarding = false;
    }
  }

	ngAfterViewChecked() {
		if (!this.shouldFocusEditor) {
			return;
		}
		this.shouldFocusEditor = false;
		setTimeout(() => this.safeFocusEditor(), 0);
  	}

	private enableEditorAndFocus() {
		this.formReadOnly = false;
		this.editorLoading = true;
		this.shouldFocusEditor = true;
		this.cdRef.detectChanges(); // ensure editor enters DOM
	}

	onEditorInit() {
		this.editorLoading = false;
	}

	private safeFocusEditor() {
		const editor: any = this.mailEditor?.editor;
		if (!editor || editor.destroyed || editor.removed) {
			return;
		}
		try {
			editor.focus();
		} catch {
		}
	}

	sendMail() {
		try {
			if (this.isSending) {
				return;
			}
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}

			const emailRecipients: MsgRecipient[] = [];
			if (this.toMailIdsSelected && this.toMailIdsSelected.length > 0 ){
				for (let mail of this.toMailIdsSelected) {
					const msgRecipient = new MsgRecipient();
					msgRecipient.email = mail.emailAddress;
					msgRecipient.emailRecipientType = 'To';
					emailRecipients.push(msgRecipient);
				}
			}
			if (this.ccMailIdsSelected && this.ccMailIdsSelected.length > 0 ){
				for (const mail of this.ccMailIdsSelected) {
					const msgRecipient = new MsgRecipient();
					msgRecipient.email = mail.emailAddress;
					msgRecipient.emailRecipientType = 'Cc';
					emailRecipients.push(msgRecipient);
				}
			}
			if (this.bccMailIdsSelected && this.bccMailIdsSelected.length > 0 ){
				for (const mail of this.bccMailIdsSelected) {
					const msgRecipient = new MsgRecipient();
					msgRecipient.email = mail.emailAddress;
					msgRecipient.emailRecipientType = 'Bcc';
					emailRecipients.push(msgRecipient);
				}
			}
			if (emailRecipients.length === 0) {
				this.alertService.error('Please add at least one recipient.');
				return;
			}

			let mailSet = new Set();
			for (const receipient of emailRecipients){
				let mail = receipient.email;
				if (mailSet.has(mail)){
					this.alertService.error('To , Cc and Bcc should have unique mail Ids.');
					return;
				}
				else{
					mailSet.add(mail);
				}
			}
	//   this.form1.value.msgRecipientAPIList = emailRecipients;
    //   this.form1.value.topic = this.msgTopic;
    //   this.form1.value.topicId = this.msgTopicId;
	let mediums = ['EMAIL'];
	if(this.inbox?.msgOrigin && this.inbox?.msgOrigin == '4')
	{
		mediums = ['VRBO'];
	}
	  let msg = {
			emailHtml : this.form1.value.emailHtml,
			emailText : this.form1.value.emailText,
			subject : this.form1.value.subject,
			imapConfigurationId : this.form1.value.imapConfigId,
			replyToMsgId: this.form1.value.msgId,
			mediums: mediums,
			msgRecipients: emailRecipients,
			msgRequestAttachmentAPI: this.attachments
	  };
	//   msg.msgRecipientAPIList = emailRecipients;
	// 		msg.topic = this.msgTopic;
	// 		msg.topicId = this.msgTopicId;
			
	// 		if (this.form1.value.imapConfigId && 'null' !=this.form1.value.imapConfigId){
    //     let imap = new ImapConfiguration();
    //     imap.imapConfigurationId = this.form1.value.imapConfigId;
	// 			msg.imapConfigurationAPI = imap;
	// 		}
    //   else {
    //     msg.imapConfigurationAPI = null;
    //   }
      console.log('send message, post: ' + JSON.stringify(this.form1.value));
			this.isSending = true;
			this.inboxService.sendMail(msg).subscribe(
				(res: any) => {
					console.log("send message, SUCCESS: " + JSON.stringify(res));
					this.messageService.add({
						severity: "success",
						summary: "Success",
						detail: res.message,
					});
					this.isSending = false;
					this.inbox = res.data.msg;
					this.doUpdate.emit(this.inbox);
				},
				(err: any) => {
					console.log("msg-add FAIL: " + JSON.stringify(err));
					this.alertService.error(err);
					this.isSending = false;
				},
				() => {
				}
			);
		} catch (error) {
			this.isSending = false;
			this.alertService.error(error);
		}
	}


  replayMail() {
    try {
      if (this.isSending) {
        return;
      }
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }

      const emailRecipients: MsgRecipient[] = [];
      if (this.toMailIdsSelected && this.toMailIdsSelected.length > 0 ){
        for (let mail of this.toMailIdsSelected) {
          const msgRecipient = new MsgRecipient();
          msgRecipient.email = mail.emailAddress;
          msgRecipient.emailRecipientType = 'To';
          emailRecipients.push(msgRecipient);
        }
      }
      if (this.ccMailIdsSelected && this.ccMailIdsSelected.length > 0 ){
        for (const mail of this.ccMailIdsSelected) {
          const msgRecipient = new MsgRecipient();
          msgRecipient.email = mail.emailAddress;
          msgRecipient.emailRecipientType = 'Cc';
          emailRecipients.push(msgRecipient);
        }
      }
      if (this.bccMailIdsSelected && this.bccMailIdsSelected.length > 0 ){
        for (const mail of this.bccMailIdsSelected) {
          const msgRecipient = new MsgRecipient();
          msgRecipient.email = mail.emailAddress;
          msgRecipient.emailRecipientType = 'Bcc';
          emailRecipients.push(msgRecipient);
        }
      }
      let mailSet = new Set();
      for (const receipient of emailRecipients){
        let mail = receipient.email;
        if (mailSet.has(mail)){
          this.alertService.error('To , Cc and Bcc should have unique mail Ids.');
          return;
        }
        else{
          mailSet.add(mail);
        }
      }
      this.form1.value.msgRecipientAPIList = emailRecipients;
      this.form1.value.topic = this.msgTopic;
      this.form1.value.topicId = this.msgTopicId;
      let msg = new Msg();
      msg.msgRecipientAPIList = emailRecipients;
      msg.topic = this.msgTopic;
      msg.topicId = this.msgTopicId;
      msg.emailHtml = this.form1.value.emailHtml;
      msg.subject = this.form1.value.subject;
      if (this.form1.value.imapConfigId && 'null' !=this.form1.value.imapConfigId){
        let imap = new ImapConfiguration();
        imap.imapConfigurationId = this.form1.value.imapConfigId;
        msg.imapConfigurationAPI = imap;
      }
      else {
        msg.imapConfigurationAPI = null;
      }
      console.log('send message, post: ' + JSON.stringify(this.form1.value));
      this.isSending = true;
      this.inboxService.replyMail(msg).subscribe(
        (res: any) => {
          console.log("send message, SUCCESS: " + JSON.stringify(res));
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
          this.isSending = false;
          this.inbox = res.data.msg;
          this.doUpdate.emit(this.inbox);
        },
        (err: any) => {
          console.log("msg-add FAIL: " + JSON.stringify(err));
          this.alertService.error(err);
          this.isSending = false;
        },
        () => {
        }
      );
    } catch (error) {
      this.isSending = false;
      this.alertService.error(error);
    }
  }

	formBuild() {
		this.form1 = this.formBuilder.group({
			msgId: [],
			sentDate: [],
			receivedDate: [],
			senderName: [],
			senderEmail: [],
			senderMobileNum: ['+91'],
			senderCountryCode: ['9999999999'],
			subject: ['', Validators.required],
			preHeader: [],
			emailHtml: [],
			replyEmailHtml: [],
			emailText: [],
			mobileText: [],
			headers: [],
			status: [],
			statusMsg: [],
			confId: [],
			trackingId: [],
			opsNotes: [],
			campaignVars: [],
			msgRecipientAPIList: [],
			topic: [],
			topicId: [],
			toEmails: [],
			ccEmails: [],
			bccEmails: [],
			msgTemplateId: [],
			imapConfigId: [],
		});
	}

  openCreateTask(selectedNode: Inbox) {
    const dialogConfig = new MatDialogConfig();

	// settings
	dialogConfig.width = '100vw';
	dialogConfig.height = '100vh';
	dialogConfig.maxWidth = '100vw';
	dialogConfig.maxHeight = '100vh';
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    let sel = selectedNode as object;
    // pass data, ie rateBuicket: this.shortTermRentalId,
	  let custTaskApi = {name: selectedNode.subject};
    dialogConfig.data = {
      title: 'Assign Task',
      isModal: true,
      action: 'create',
      purpose: 'createmailtask',
	 taskApi: custTaskApi,
      msg: sel as Msg
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(TaskComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    dialogRef.componentInstance.doAdd.subscribe(
      data => {
        console.log('Dialog output:', data);
        let msg  =  new Msg();
        let taskAPI = {
          taskId: undefined
        };
        // @ts-ignore
        msg.msgId = sel?.msgId;
        taskAPI.taskId = data.taskId;
        msg.taskAPI = taskAPI;
        try {
          this.msgService.findById(msg.msgId).subscribe(
            (res: any) => {
              console.log('property-update SUCCESS: ' + JSON.stringify(res));
				this.inbox = res?.data?.msg;
				this.doUpdateAndDontClose.emit(this.inbox);
              this.messageService.add({
                severity: 'success',
                summary: 'Task Created',
                detail: res.message,
              });
            },
            (err: any) => {
              console.log('property-update FAIL: ' + JSON.stringify(err));
              this.alertService.error(err);
            },
            () => {
            }
          );
        } catch (error) {
          console.log('Form Invalid: ' + JSON.stringify(error));
          this.alertService.error(error);
        }
        dialogRef.close();
      });
  }

   openCreateCompanionTask(selectedNode: Inbox) {
    const dialogConfig = new MatDialogConfig();

	   // settings
	   dialogConfig.width = '100vw';
	   dialogConfig.height = '100vh';
	   dialogConfig.maxWidth = '100vw';
	   dialogConfig.maxHeight = '100vh';
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    let sel = selectedNode as object;
    // pass data, ie rateBuicket: this.shortTermRentalId,
	  let custTaskApi = {name: 'Companion Task', companionTask: true};
    dialogConfig.data = {
      title: 'Assign Task',
      isModal: true,
      action: 'create',
      purpose: 'createmailtask',
	 taskApi: custTaskApi,
      msg: sel as Msg
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(TaskComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    dialogRef.componentInstance.doAdd.subscribe(
      data => {
        console.log('Dialog output:', data);
        let msg  =  new Msg();
        let taskAPI = {
          taskId: undefined
        };
        // @ts-ignore
        msg.msgId = sel?.msgId;
        taskAPI.taskId = data.taskId;
        msg.taskAPI = taskAPI;
        try {
          this.msgService.findById(msg.msgId).subscribe(
            (res: any) => {
              console.log('property-update SUCCESS: ' + JSON.stringify(res));
				this.inbox = res?.data?.msg;
				this.doUpdateAndDontClose.emit(this.inbox);
              this.messageService.add({
                severity: 'success',
                summary: 'Task Created',
                detail: res.message,
              });
            },
            (err: any) => {
              console.log('property-update FAIL: ' + JSON.stringify(err));
              this.alertService.error(err);
            },
            () => {
            }
          );
        } catch (error) {
          console.log('Form Invalid: ' + JSON.stringify(error));
          this.alertService.error(error);
        }
        dialogRef.close();
      });
  }

  openTapChart(selectedNode: Inbox) {
    const dialogConfig = new MatDialogConfig();
    const data = {
      msgOrigin: 1
    };
    // settings
	dialogConfig.width = '100%';
	dialogConfig.height = '100%';
	dialogConfig.maxWidth = '1600px';
	dialogConfig.maxHeight = '800px';
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.maxWidth = '120vw';
    dialogConfig.width = '75vw';

    // Make sure we have fresh context (e.g. user edited the body before opening)
    if (!this.parsedContext) { this.runSmartParse(); }

    // Always open the tape chart in standard (non-flex) mode so the date
    // grid shows without the Best Fit finder panel on top.
    // For flex emails, map the range dates to explicit checkIn/checkOut so
    // the tape chart can still pre-fill the search form correctly.
    const tcContext: QuoteContext | null = this.parsedContext
      ? {
          ...this.parsedContext,
          flexMode:     false,
          checkInDate:  this.parsedContext.checkInDate  ?? this.parsedContext.flexRangeStart  ?? null,
          checkOutDate: this.parsedContext.checkOutDate ?? this.parsedContext.flexRangeEnd    ?? null,
        }
      : null;

    dialogConfig.data = {
      title : 'Tape Chart',
      showCloseButton: true,
      msgOrigin: 1,
	  msgRequest: {
			replyToMsgId : this.form1.value.msgId
		},
      quoteContext: tcContext
    };
    this.replayEMailHtml = '';

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(TapeChartWikiListComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    dialogRef.componentInstance.doEmailEvent.subscribe(
      data => {
        console.log('doSentQuoteCB output:', JSON.stringify(data));
        dialogRef.close();
        if(true) {
          this.replayEMailHtml = data?.quote?.msgResponse?.msges[0].emailHtml + this.emailHtml;
        }
        this.btnReplayEmail.nativeElement.click();

      });

  }

  /**
   * Opens BestFitListComponent as a full-screen dialog, pre-filled with the
   * smart-parsed quote context from the email (flex dates, nights, resort, etc.).
   * The component detects MAT_DIALOG_DATA on ngOnInit and auto-triggers the search.
   */
  /**
   * Opens BestFitListComponent as a full-screen dialog.
   * - If Smart Parse detected a flex request (flexMode=true): pre-fills dates,
   *   night pills, resort and auto-triggers the search immediately.
   * - If the email has non-flex context (resort, dates): pre-fills what's
   *   available but leaves the user to click Search.
   * - If no context at all: opens with an empty form for the user to fill.
   */
  openBestFitList(selectedNode: Inbox): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus    = true;
    dialogConfig.hasBackdrop  = true;
    dialogConfig.maxWidth     = '120vw';
    dialogConfig.width        = '85vw';
    dialogConfig.maxHeight    = '90vh';
    dialogConfig.data = {
      title:           'Best Fit Finder',
      showCloseButton: true,
      msgOrigin:       1,
      msgRequest:      { replyToMsgId: this.form1.value.msgId },
      // Pass whatever context we have — component handles null gracefully
      quoteContext:    this.parsedContext ?? null
    };

    const bflRef = this.dialog.open(BestFitListComponent, dialogConfig);
    bflRef.componentInstance.quoteAdded.subscribe((payload: any) => {
      // payload is { message, quoteId } bubbled up from best-fit — email is async.
      const message = typeof payload === 'string' ? payload : payload?.message;
      const quoteId = typeof payload === 'string' ? null  : payload?.quoteId;
      this.messageService.add({ severity: 'info', summary: '📨 Quote Saved', detail: message, life: 8000 });
      if (quoteId) {
        setTimeout(() => {
          this.quoteService.getEmailStatus(quoteId).subscribe((res: any) => {
            if (res?.data?.emailStatus?.emailSendStatus === 4) {
              const errorDetail = res?.data?.emailStatus?.emailSendStatusMsg
                || 'The email could not be delivered to the guest.';
              this.messageService.add({
                severity: 'error', summary: '⚠️ Email Delivery Failed',
                detail: errorDetail, life: 0
              });
            }
          });
        }, 5000);
      }
    });
  }

  archiveMsg(selectedNode: Inbox) {
    try {
      this.isArchiving = true;
      let msg  =  new Msg();
      let sel = selectedNode as object;
      // @ts-ignore
      msg.msgId = sel?.msgId;
      msg.msgFolder = 2;  // 2 is for archive folder
      this.msgService.archiveMsg(msg).subscribe(
        (res: any) => {
          console.log('property-update SUCCESS: ' + JSON.stringify(res));
          this.isArchiving = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Archived',
            detail: res.message,
          });
        //   this.doDelete.emit(this.inbox);
		  this.doArchive.emit(this.inbox);
        },
        (err: any) => {
          console.log('property-update FAIL: ' + JSON.stringify(err));
          this.isArchiving = false;
          this.alertService.error(err);
        },
        () => {
        }
      );
    } catch (error) {
      this.isArchiving = false;
      console.log('Form Invalid: ' + JSON.stringify(error));
      this.alertService.error(error);
    }
  }
  toMailSelected($event: any) {
    this.toMailIdsSelected = $event;
  }
  ccMailSelected($event: any) {
    this.ccMailIdsSelected = $event;
  }
  bccMailSelected($event: any) {
    this.bccMailIdsSelected = $event;
  }

  private getStrToEMails(mailAraay) {
    let mails = '';
    if ( !mailAraay || mailAraay?.length === 0 ){
      return null;
    }
    mails = mailAraay[0]?.emailAddress;
    for ( let i = 1; i < mailAraay?.length; i++){
      if ( mailAraay[i]?.emailAddress){
        mails = mails + ',' + mailAraay[i]?.emailAddress;
      }
    }
    return mails;
  }
	openViewTask(rowData: any) {
		if (rowData.taskAPIList?.length > 1) {
			const dialogConfig = new MatDialogConfig();
			// settings
			dialogConfig.width = '100%';
			dialogConfig.height = '100%';
			dialogConfig.maxWidth = '1600px';
			dialogConfig.maxHeight = '800px';
			dialogConfig.disableClose = false;
			dialogConfig.autoFocus = true;
			dialogConfig.hasBackdrop = true;
			// pass data, ie rateBuicket: this.shortTermRentalId,
			dialogConfig.data = {
				title: 'Mail Tasks',
				isModal: true,
				parentMsgId: rowData.msgId,
				fromMail: true,
				showFilter: false,
				showPagination: false,
				outlineNewButton: false,
			};
			const dialogRef = this.dialog.open(TaskListComponent, dialogConfig);
		} else {
			const dialogConfig = new MatDialogConfig();
			dialogConfig.width = '100vw';
			dialogConfig.height = '100vh';
			dialogConfig.maxWidth = '100vw';
			dialogConfig.maxHeight = '100vh';
			dialogConfig.disableClose = false;
			dialogConfig.autoFocus = true;
			dialogConfig.hasBackdrop = true;
			dialogConfig.data = {
				title: 'Assign Task',
				isModal: true,
				taskApi: rowData?.taskAPIList[0],
				fromMail: false
			};

			const dialogRef = this.dialog.open(TaskComponent, dialogConfig);
			dialogRef.componentInstance.doAdd.subscribe(
				data => {
					console.log('Dialog output:', data);
					dialogRef.close();
				});
		}
	}
	fetchAllTemplatesSummary() {
		if (!this.msgTemplates || this.msgTemplates === undefined || this.msgTemplates.length < 1) {
			try {
				let params: any = {};
				if (this.templateMsgAudience) {
					params.msgAudience = this.templateMsgAudience;
				}
				this.msgTemplateService.fetchAllTemplatesSummary(params)
					.subscribe(
						res => {
							console.log('employee Profiles: ' + JSON.stringify(res));
							this.msgTemplates = res.data.msgTemplates;
							return this.msgTemplates;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			return (this.msgTemplates);
		}
	}
	selectTemplate(event)
	{
		try {
        this.msgTemplateService.findById(event?.value)
          .subscribe(
            res => {
				const template = res.data?.msgTemplate;

				// emailHtml
				const baseHtml = this.baseEmailHtml || '';  // original DB/reply HTML
				let updatedHtml = '';

				if (template.emailHtml && template.emailHtml.trim() !== '') {
					if (baseHtml && baseHtml.trim() !== '') {
						// Put template before base HTML (or after if you prefer)
						updatedHtml = template.emailHtml + '<br>' + baseHtml;
					} else {
						// If no base HTML, just template
						updatedHtml = template.emailHtml;
					}
				} else {
					// If template has no HTML, just restore the base/original HTML
					updatedHtml = baseHtml;
				}

				//emailText
				const baseText = this.baseEmailText || '';  // original DB/reply text

				if (template.emailText && template.emailText.trim() !== '') {
					let emailText = '';

					if (baseText && baseText.trim() !== '') {
						// Put template before base text (or after if you prefer)
						emailText = template.emailText + '\n\n' + baseText;
					} else {
						// If no base text, just template
						emailText = template.emailText;
					}

					this.form1.patchValue({
						emailText: emailText,
					});
				} else {
					// If template has no text, just restore the base/original text
					this.form1.patchValue({
						emailText: baseText,
					});
				}
				
				const currentSubject = this.form1.get('subject')?.value;
				this.form1.patchValue({
					emailHtml: updatedHtml,
					...(currentSubject ? {} : { subject: template.subject })
				});
            },
            err => {
              this.alertService.error(err);
            },
            () => { });
      } catch (error) {
        console.log('Form Invalid: ' + JSON.stringify(error));
        this.alertService.error(error);
      }
	}

	onFilesSelect(event: any) {
		for (const file of event.files) {
			const reader = new FileReader();
			reader.onload = () => {
					const base64Data = (reader.result as string).split(',')[1];
					this.attachments.push({
						filename: file.name,
						contentType: file.type,
						contentBytes: base64Data
					});
				};
			reader.readAsDataURL(file);
		}
	}

	removeAttachment(index: number) {
	this.attachments.splice(index, 1);
	}




  getAttachmentIcon(fileNameOrType: string): string {
    if (!fileNameOrType) return 'pi pi-file';
    const val = fileNameOrType.toLowerCase();
    if (val.includes('pdf')) return 'pi pi-file-pdf';
    if (val.match(/\.(jpg|jpeg|png|gif|webp|svg)/) || val.startsWith('image/')) return 'pi pi-image';
    if (val.match(/\.(xls|xlsx)/) || val.includes('spreadsheet') || val.includes('excel')) return 'pi pi-file-excel';
    if (val.match(/\.(doc|docx)/) || val.includes('word')) return 'pi pi-file-word';
    if (val.match(/\.(zip|tar|gz|rar)/)) return 'pi pi-file-zip';
    return 'pi pi-file';
  }

	cancelEdit() {
		this.form1.patchValue({
			subject: this.inbox?.subject || '',
			emailHtml: this.inbox?.emailHtml || '',
			emailText: this.inbox?.emailText || '',
			msgTemplateId: null
		});

		this.isSendEnable = false;
		this.isReplyEnable = true;
		this.formReadOnly = true;
	}


}
